import { Map } from 'immutable';
import actions from './actions';

const initState = new Map({
  success: false ,
  msg:'',
  result: [],
});

export default function grpSwitchReducer(state = initState, action) {
 console.log('action',action);
  switch (action.type) {
  case actions.GRP_SWITCH_LIST_ID:
  return state
   .set('result', action.result)
   .set('success', action.success);
    default:
      return state;
  }
  //return state;
}
